<template>
  <div class="bangdan">
    <div class="rank">
      <Rank :isShowSelf="false"
        :province_id="province_id"
        :switchPeriod="period_id"
        type="page"
      />
    </div>
  </div>
</template>
<script>
import Rank from './home/components/tabs/rank.vue'
export default {
  name: 'Apply',
  components: {
    Rank
  },
  data() {
    return {
      period_id: '',
      province_id: ''
    }
  },

  created() {
    this.$xesLogger.clickMsg({
      params: { clickid: '201', elemname: '助力榜单页' }
    })
    const { period_id, province_id } = this.$route.query || {}
    this.period_id = period_id
    this.province_id = province_id
  }
}
</script>
<style lang="less">
.bangdan {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #ca0909;

  .rank {
    margin: 24px/2;
    overflow: hidden;
    background: #fefefe;
    border: 1px solid #ffdc51;
    border-radius: 16px/2;
    box-shadow: 0 0 24px 0 rgba(191, 191, 191, 0.31), 0 -1px 0 0 #f7f1e2;
  }
}
</style>
